<template>
  <div class="bkRank-container">
    <!-- <Header :nosearch="false" :height="50" :title="`板块排行`" /> -->
    <ComHeader type="4" :title="'板块'" :drop-menu-active="3" />
    <div class="tabs-container">
      <div
        v-for="(item, index) in tabList"
        :class="{ active: index === tabActive }"
        :key="index"
        @click="tabClick(index)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="bkRank-table">
      <div class="bkRank-table-th">
        <span class="name">行业名称</span>
        <span class="price right-align" @click="clickSort('price', priceSort)"
          >最新价<img :src="sortSrc[priceSort]" alt=""
        /></span>
        <span class="rate right-align" @click="clickSort('rate', rateSort)"
          >涨跌幅<img :src="sortSrc[rateSort]" alt=""
        /></span>
        <span class="stock right-align">领涨股</span>
      </div>
      <div class="bkRank-table-content">
        <div class="bkRank-table-td" v-for="(item, index) in list" :key="index">
          <div class="name" @click="gotoBk(item)">
            <p class="line-ellipsis stock-name">{{ item.ProdName }}</p>
            <div :style="'display: flex;align-items: center;'">
              <img :src="getPath('searchIconPlate')" class="bk-icon" /><span
                class="stock-symbol"
                >{{ item.ProdCode }}</span
              >
            </div>
          </div>
          <p
            class="cl price right-align"
            :style="{ color: getColor(item.PxChangeRate) }"
          >
            {{
              badData(item.PxChangeRate)
                ? "--"
                : newFormatUnit(item.LastPx / 1000, "", true, 2)
            }}
          </p>
          <p
            class="cl rate right-align"
            :style="{ color: getColor(item.PxChangeRate) }"
          >
            {{
              badData(item.PxChangeRate) ? "--" : rate(item.PxChangeRate / 10)
            }}
          </p>
          <p
            class="stock right-align line-ellipsis lzg-name"
            @click="gotoStock(item)"
          >
            {{ item.RiseFirstGrp[0].ProdName }}
          </p>
        </div>
        <infinite-loading
          ref="bkinf"
          @infinite="infiniteHandler"
          direction="bottom"
          :distance="100"
          :forceUseInfiniteWrapper="true"
        >
          <div class="center-align" slot="no-more">无更多数据</div>
          <div
            v-if="list.length === 0"
            slot="no-results"
            class="no-results"
          ></div>
          <div v-else slot="no-results"></div>
          <div slot="spinner" class="tab-spinner center-align">
            正在加载...
          </div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { request } from '@/api/request'
import { rate, getColor, newFormatUnit } from '@/utils/formatUnit.js'
// import Header from '@/components/header.vue'
import InfiniteLoading from 'vue-infinite-loading'
import ComHeader from '@/components/common/comHeader.vue'
import { getPath } from '@/utils/getOssFilePath'

export default {
    components: { ComHeader, InfiniteLoading },
    data() {
        return {
            rate,
            getColor,
            newFormatUnit,
            rankInterval: null,
            total: 0,
            pageNum: 1, // 下拉加载使用
            sortParams: {
                sortFields: 'PxChangeRate', // 排序 LastPx-最新价 PxChangeRate-涨跌幅
                sortFlag: true, // 0-从小到大，1-从大到小
                pageSize: 30,
                pageNum: 1
            },
            priceSort: 'default',
            rateSort: 'desc',
            sortSrc: {
                default: require('@/assets/sort-default.png'),
                desc: require('@/assets/sort-desc.png'),
                asc: require('@/assets/sort-asc.png')
            },
            tabActive: parseInt(this.$route.query.tab) || 0,
            tabList: [
                {
                    title: '行业'
                },
                {
                    title: '概念'
                },
                {
                    title: '地区'
                }
            ],
            list: [],
            hqType: ['HY', 'GN', 'DY']
        }
    },
    created() {
        this.rankInterval = setInterval(() => {
            this.rankApi(true)
        }, 5000)
    },
    beforeDestroy() {
        clearInterval(this.rankInterval)
    },
    methods: {
        getPath,
        async infiniteHandler($state) {
            let canload = await this.rankApi()
            if (canload) $state.loaded()
            else $state.complete()
        },
        async rankApi(isSort = false) {
            const HqTypeCode = this.hqType[this.tabActive]
            const params = {
                hqTypeCode: HqTypeCode,
                pageNum: isSort ? 1 : this.pageNum,
                pageSize: isSort ? this.list.length : 30,
            }
            this.sortParams = { ...this.sortParams, ...params }
            let res = await request._get(
                request.apis.quote.bkRank,
                this.sortParams,
                true
            )
            let list = res.plate || []
            this.total = res.counts || 0
            if (isSort) {
                this.list = list
                return true
            } else {
                if (!list.length) return false
                this.list = this.list.concat(list)
                this.pageNum += 1
                return true
            }
        },
        clickSort(type, sort) {
            const params = {
                sortFields: type === 'rate' ? 'PxChangeRate' : 'lastPx',
                sortFlag: this.handleSort(sort) === 'desc' ? true : false
            }
            this.sortParams = { ...this.sortParams, ...params }
            if (type === 'price') {
                this.priceSort = this.handleSort(sort)
                this.rateSort = 'default'
            } else {
                this.rateSort = this.handleSort(sort)
                this.priceSort = 'default'
            }
            this.rankApi(true)
        },
        handleSort(sort) {
            if (sort === 'default') {
                return 'desc'
            }
            if (sort === 'desc') {
                return 'asc'
            }
            if (sort === 'asc') {
                return 'desc'
            }
        },
        tabClick(index) {
            if (this.tabActive === index) return
            if (!this.$refs.bkinf.stateChanger) return
            this.$refs.bkinf.stateChanger.reset()
            this.tabActive = index
            this.pageNum = 1
            this.list = []
            this.sortParams = {
                sortFields: 'PxChangeRate', // 排序 LastPx-最新价 PxChangeRate-涨跌幅
                sortFlag: true, // 0-从小到大，1-从大到小
                pageSize: 30,
                pageNum: 1
            }
            // this.rankApi()
        },
        gotoBk(item) {
            const { ProdCode = '', HqTypeCode = '' } = item
            this.$router.push({
                path: `/plate/${HqTypeCode}/${ProdCode}.html`,
            })
        },
        gotoStock(item) {
            const { RiseFirstGrp = [] } = item
            const { ProdCode, ProdName = '', HqTypeCode = '' } = RiseFirstGrp[0]
            this.$router.push({
                path: `/${HqTypeCode}/${ProdCode}.html`,
            })
        },
        badData(val) {
            return [undefined, null, ''].includes(val)
        }
    }
}
</script>

<style lang="stylus" scoped>
div
    box-sizing border-box

.line-ellipsis
    width 100%
    display inline-block
    overflow hidden
    text-overflow ellipsis
    white-space nowrap

.right-align
    text-align right

.center-align
    text-align center

.bkRank-container
    display flex
    flex-direction column
    background #fff
    width 100%
    height 100vh
    color #333333

.bkRank-table
    display flex
    flex-direction column
    height 0
    flex 1
    padding 10px 16px 0 16px

    .price
        width 65px
        margin-right 18px

    .rate
        width 65px
        margin-right 18px

    .stock
        width 70px

    .cl
        align-items center
        display flex
        justify-content flex-end
        font-family: DIN-Medium, DIN !important;

    .name
        width 0
        flex 1
        display flex
        flex-direction column
        justify-content space-between
        width 110px

    .bkRank-table-content
        // height 0
        // flex 1
        // overflow-y auto

    .bkRank-table-th
        display flex
        justify-content space-between
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #BBBBBB;
        min-height 30px
        line-height 30px


        img
            width 7px
            margin-left 4px

    .bkRank-table-td
        display flex
        justify-content space-between
        align-items center
        height 58px
        line-height 58px
        color #999

        .name
            line-height initial

        p
            // line-height 24px
            font-size 17px
            font-weight 500
            color #333

        .stock-name
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
            margin-bottom: 2px;

        .lzg-name
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;

        .stock-symbol
            font-size: 14px;
            font-family: DIN-Regular, DIN !important;
            font-weight: 400;
            color: #999999;
            line-height: 14px;

    .bk-icon
        width: 17px;
        height: 12px;
        margin-right 4px

.tabs-container
    display flex
    align-items center
    justify-content space-between
    height 45px
    padding 12px 64px
    border-bottom 1px solid #F2F5F8
    > div
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 25px;
        &.active
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 25px;
            position relative
            &:after
                content ''
                position absolute
                top 31px
                width 20px
                height 4px
                border-radius 3px
                background #B60014
                bottom 0
                left 50%
                margin-left -10px
</style>
